const productsActionTypes = {
    SET_PRODUCTS_OBJECT:'SET_PRODUCTS_OBJECT',
    ADD_PRODUCT:'ADD_PRODUCT',
    EDIT_PRODUCT:'EDIT_PRODUCT',
    DELETE_PRODUCT:'DELETE_PRODUCT'
}

export default productsActionTypes